import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPr = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 900 600", fill: "#FFF", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h900v600H0" }), /* @__PURE__ */ React.createElement("path", { stroke: "red", strokeWidth: 120, d: "M0 60h900m0 240H0m0 240h900" }), /* @__PURE__ */ React.createElement("path", { fill: "#06F", d: "M0 0v600l520-300" }), /* @__PURE__ */ React.createElement("path", { d: "M114 382l59-183 59 183L77 269h192" }));
const ForwardRef = forwardRef(SvgPr);
const Memo = memo(ForwardRef);
export default Memo;
